import { configureStore as configureStoreReduxToolkit } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';

import langReducer from '#configuration/lang/langSlice.ts';
import loginReducer from '#configuration/login/loginSlice.ts';
import tokenReducer from '#configuration/tokenHandling/tokenSlice.ts';

import { apiBooking } from './apiBookingRoot.ts';
import { apiRootDocuments } from './apiDocumentsRoot.ts';
import { apiNotificationsRoot } from './apiNotificationsRoot.ts';
import { apiPoisRoot } from './apiPoisRoot.ts';
import { apiTagsRoot } from './apiTagsRoot.ts';
import { apiV2Root } from './apiV2Root.ts';
import { cartRightUnavailableTrackingMiddleWare } from './cartRightUnavailableTrackingMiddleWare.ts';

export const configureStore = () =>
    configureStoreReduxToolkit({
        reducer: {
            lang: langReducer,
            login: loginReducer,
            tokenHandling: tokenReducer,
            [apiV2Root.reducerPath]: apiV2Root.reducer,
            [apiRootDocuments.reducerPath]: apiRootDocuments.reducer,
            [apiNotificationsRoot.reducerPath]: apiNotificationsRoot.reducer,
            [apiPoisRoot.reducerPath]: apiPoisRoot.reducer,
            [apiBooking.reducerPath]: apiBooking.reducer,
            [apiTagsRoot.reducerPath]: apiTagsRoot.reducer,
        },
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware()
                .concat(apiV2Root.middleware)
                .concat(apiRootDocuments.middleware)
                .concat(apiNotificationsRoot.middleware)
                .concat(apiPoisRoot.middleware)
                .concat(apiBooking.middleware)
                .concat(apiTagsRoot.middleware)
                .concat(cartRightUnavailableTrackingMiddleWare),
    });

export const store = configureStore();
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
